import { startOfToday, startOfYesterday, startOfMinute, isToday } from 'date-fns'


export const getToday = () => startOfToday()//startOfMinute(new Date)
export const getYesterday = () => startOfYesterday()
